




























/**
 * @copyright       Palace Resorts
 * @description     Modal para ver los pagos por factura
 */
import GlobalMixin from "@/mixins/global";
import DatatablePayment from "@/components/DatatablePayment/DatatablePayment.vue";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma

  components: {
    DatatablePayment,
  },

  props: [
    "dialog", "factura", "pago", "loading", "headers"
  ],
  data: () => {
    return {
      // GENERAL
      moduleName: "MODAL_VIEW_PAYMENT",
      DatatablePayments: [],
      headersRegistroPagos: [],
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
  },
  computed: {},
  mounted() {

  },
});
